module.exports = require('./lib/linkify-element').default;



//////////////////
// WEBPACK FOOTER
// ./~/linkifyjs/element.js
// module id = SkOz
// module chunks = 0